import { Component } from "@angular/core";

@Component({
  standalone: true,
  selector: "vts-not-found",
  templateUrl: "not-found.html",
})
export class NotFound {}
